import { render } from "./UserProfileFollowingSection.vue?vue&type=template&id=c8ef8046"
import script from "./UserProfileFollowingSection.vue?vue&type=script&lang=js"
export * from "./UserProfileFollowingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__